(function () {
  var track = document.getElementById('dsCards');
  var thumb = document.getElementById('dsScrollThumb');
  if (track && thumb) {
    function updateThumb() {
      var scrollable = track.scrollWidth - track.clientWidth;
      if (scrollable <= 0) return;
      var ratio = track.scrollLeft / scrollable;
      var thumbMax = thumb.parentElement.clientWidth - thumb.offsetWidth;
      thumb.style.left = (ratio * thumbMax) + 'px';
    }
    track.addEventListener('scroll', updateThumb, { passive: true });
    updateThumb();
  }
})();
